const allUnits = (allUnits = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_UNITS':
      return action.payload
    default:
      return allUnits
  }
}
export default allUnits
